export interface Country {
  id: string
  name: string
  code: string
}

export const countryConverter: firebase.firestore.FirestoreDataConverter<Country> = {
  toFirestore: (country) => {
    return {
      name: country.name,
      code: country.code
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    return {
      id: snapshot.id,
      name: data.name,
      code: data.code
    }
  }
}
